module.exports = __webpack_public_path__ + "static/media/017ty@4x.2082cca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/017ty@4x.png
// module id = 421
// module chunks = 0 1